import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "document-event-modal-content py-4 px-3 lg:px-4" }
const _hoisted_2 = { class: "document-event-description w-full" }
const _hoisted_3 = { class: "mb-3 flex align-items-center" }
const _hoisted_4 = { class: "mr-1" }
const _hoisted_5 = {
  key: 0,
  class: "font-bold mt-1 text-dark-medium"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-3 flex align-items-center"
}
const _hoisted_7 = { class: "mr-1" }
const _hoisted_8 = {
  key: 2,
  class: "mb-3 flex align-items-center"
}
const _hoisted_9 = {
  key: 3,
  class: "mb-3 attendees-select flex align-items-center sm:w-11"
}
const _hoisted_10 = {
  key: 3,
  class: "flex justify-content-between font-bold"
}
const _hoisted_11 = {
  key: 4,
  class: "pt-3 mt-4 mb-3 border-top-3 border-gray-200"
}
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = {
  key: 5,
  class: "mb-3 attendees-select flex align-items-start sm:w-11"
}
const _hoisted_14 = {
  key: 6,
  class: "pt-3 pl-1 mt-4 mb-3 border-top-3 border-gray-200"
}
const _hoisted_15 = ["textContent"]
const _hoisted_16 = {
  key: 0,
  class: "document-event-attendees flex flex-column p-0 m-0 list-none"
}
const _hoisted_17 = {
  key: 0,
  class: "flex justify-content-between"
}
const _hoisted_18 = { class: "field-row flex flex-column" }
const _hoisted_19 = { class: "field mt-3 required flex flex-column" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "p-error" }
const _hoisted_22 = { class: "field flex flex-1 flex-column mt-3 required" }
const _hoisted_23 = {
  class: "flex w-full justify-content-end mt-2 h-2rem -ml-2 w-9rem ml-auto mr-3",
  style: {"margin-bottom":"-60px"}
}
const _hoisted_24 = { class: "field flex flex-column required h-10rem" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "p-error" }
const _hoisted_27 = {
  key: 1,
  class: "field-row flex"
}
const _hoisted_28 = { class: "field flex flex-column mt-3" }
const _hoisted_29 = { class: "flex-row" }
const _hoisted_30 = { class: "flex align-items-center" }
const _hoisted_31 = { class: "p-error" }
const _hoisted_32 = { class: "document-event-goals" }
const _hoisted_33 = {
  key: 0,
  class: "document-event-goals-switch flex mt-3 pt-3 align-items-center"
}
const _hoisted_34 = {
  key: 1,
  class: "document-event-goals"
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 0,
  class: "p-dialog-footer document-event-modal-footer flex justify-content-between"
}
const _hoisted_37 = { class: "flex flex-row" }

import { computed, markRaw, nextTick, onMounted, provide, Ref, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { RRule } from 'rrule';
import Chip from 'primevue/chip';
import InputSwitch from 'primevue/inputswitch';
import MultiSelect from 'primevue/multiselect';
import Dialog from 'primevue/dialog';
import Editor from 'primevue/editor';
import Dropdown from 'primevue/dropdown';
import useVuelidate from '@vuelidate/core';
import type Quill from 'quill';
import { helpers, requiredIf } from '@vuelidate/validators';
import { can, useDateTime, useGetInitialRRuleObject, usePersonTypes } from '@/composables';
import { PercentageGoals, TrialsGoals } from '@/components/Goals';
import { EMIT, PERMISSIONS, GOAL_TYPE, EVENT_TYPE, THERAPY_RESULT_TYPES_NAME } from '@/enum';
import { ClinicianService } from '@/services';
import { useCalendarStore, useEventsModalsStore, useAuthStore } from '@/store';
import {
  Attendee,
  DetailedEventInterface,
  GoalInterface,
  GoalMeasurementsInterface,
  TherapyResultsInterface,
  TherapyResultTypeInterface,
  TreatmentPlanServiceStudentInterface,
} from '@/types';
import DocumentationItem from '@/views/Calendar/components/EventModal/components/DocumentationItem.vue';
import CalendarOverlappingEvents from '@/components/CalendarOverlappingEvents';
import { EventProcessTypeModal } from './index';
import templates from './DocumentEventTemplates/document_events_templates';
import EventEvaluationAssessmentsFiles from './EventEvaluationAssessmentsFiles.vue';

interface Props {
  eventToDocument: DetailedEventInterface;
  documentModalOpened: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentEventModal',
  props: {
    eventToDocument: {},
    documentModalOpened: { type: Boolean }
  },
  emits: [
  EMIT.SAVE_DOCUMENT_EVENT,
  EMIT.CLOSE_MODAL,
  EMIT.EDIT_EVENT,
  'openPastDocuments',
  'changeMultiAttendee',
],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const calendarStore = useCalendarStore();
const eventsModalsStore = useEventsModalsStore();
const authStore = useAuthStore();
const submitted: Ref<boolean> = ref(false);
const dateUtilities = useDateTime();

const props = __props;
const event = ref<DetailedEventInterface>(props.eventToDocument);

const { therapyResultTypes } = storeToRefs(calendarStore);
const { clickedEventClickArgs } = storeToRefs(eventsModalsStore);

const displayDocumentVirtualEventConfirmModal = ref(false);
const overlappingError = ref<boolean>(false);
const displayPastEventsModal = ref(false);
const isCaseManagerOwnEvent = usePersonTypes.isCaseManager() && event.value.host_id === authStore.user?.id;
const isAdmin =
  usePersonTypes.isSupportAdminOrSchoolAdmin() ||
  usePersonTypes.isSuperAdmin() ||
  (usePersonTypes.isCaseManager() && !isCaseManagerOwnEvent);
const isClinician = usePersonTypes.isClinician() || isCaseManagerOwnEvent;
const isLocked = calendarStore.selectedEvent.is_locked;
const isEditable = dateUtilities.isSameMonthAndYear(new Date(event.value.display_start_at as string));
const shouldCheckOverlappingEvents = ref<boolean>(false);
const originalAttendees = ref([...event.value.attendees]);
const templateType = ref([]);

const getTherapyResult = (studentId: number | string) => {
  return event.value.therapy_results.find((result) => result.student_id === studentId);
};

const multiAttendee = ref(
  event.value.attendees.map((a) => {
    a.selectedAttendance = getTherapyResult(a.attendee_id as number)?.id;
    return a;
  }),
);

const hostTimezone = computed<string | undefined>(
  () => event.value?.host_timezone_name || authStore?.user?.timezone?.name,
);

const changeRRuleTimeZone = () => {
  if (eventRRule.value.options && hostTimezone.value) {
    const start = dateUtilities.formatTimeByTimezone(
      event.value?.display_start_at as string,
      hostTimezone.value as string,
      true,
    );

    const until = dateUtilities.formatTimeByTimezone(
      event.value?.display_end_at as string,
      hostTimezone.value as string,
      true,
    );
    eventRRule.value.options.dtstart = new Date(start);

    eventRRule.value.options.until = new Date(until);
  }
};

const displayStart = ref(
  dateUtilities.formatTimeByTimezone(event.value.display_start_at as string, event.value.host_timezone_name as string),
);
const displayEnd = ref(
  dateUtilities.formatTimeByTimezone(event.value.display_end_at as string, event.value.host_timezone_name as string),
);

onMounted(() => init());

const closeDocumentVirtualEventConfirmModal = () => (displayDocumentVirtualEventConfirmModal.value = false);

const init = async () => {
  calendarStore.clearPastDocumentations();
  if (can([PERMISSIONS.THERAPY_RESULT_TYPES_INDEX])) {
    await calendarStore.getTherapyResultTypes();
  }

  if (can([PERMISSIONS.CLINICIAN_STUDENTS_INDEX])) {
    const responseStudents = await ClinicianService.getStudentsOfClinicianRequest(event.value.host_id);
    let availableAttendees = responseStudents.data.data.filter((a) =>
      a.treatment_services.find(
        (s: TreatmentPlanServiceStudentInterface) =>
          s.is_active && s.is_group && (event.value.discipline ? s.discipline.id == event.value.discipline.id : true),
      ),
    );

    const attendeeIdsThatBelongsToEvent = event.value.attendees.map((a) => a.attendee_id);
    availableAttendees = filterAttendeesByOrganization(availableAttendees);
    const attendeeThatDoesNotBelongToEvent = availableAttendees.filter(
      (a: Attendee) => !attendeeIdsThatBelongsToEvent.includes(a.id),
    );

    const is_group = event.value.attendees.find((a) => a.treatment_services.find((s) => s.is_group));

    if (event.value.attendees.length > 1 || is_group) {
      generateFlaggedTherapyResults(attendeeThatDoesNotBelongToEvent);
    }
  }
  prepareBindData();
  changeRRuleTimeZone();
  emit('changeMultiAttendee', multiAttendee.value);
};

const generateFlaggedTherapyResults = (possibleNewAttendees: Attendee[]) => {
  possibleNewAttendees.forEach((attendee) => {
    let cloneAttendee: Attendee = {
      id: originalAttendees.value[0].id,
      attendee_id: attendee.id,
      allowGroup: false,
    };

    cloneAttendee.new = true;
    cloneAttendee.attendee = attendee;

    let goals: GoalMeasurementsInterface[] = [];
    const treatmentServices = attendee.treatment_services.map((treatmentService) => treatmentService);
    treatmentServices.forEach((treatmentService) => goals.push(...treatmentService.goals));
    cloneAttendee.goals = goals;

    const allGoals = goals.map((goal) => {
      return {
        treatment_goal_id: goal.id,
        percentage: 0,
        description: goal.description || '',
        show_goal: false,
        treatment_goal_type_id: goal.treatment_goal_type_id,
        checkbox_order: [],
        total_trials: 10,
        trials: 0,
      };
    });

    const cloneTr = {
      duration: event.value.duration,
      event_id: event.value.id,
      goals_measurements: allGoals,
      notes: undefined,
      student_id: attendee.id,
      therapy_attendee_id: originalAttendees.value[0].id,
      therapy_result_type: undefined,
    };

    event.value.therapy_results.push(cloneTr);
    event.value.attendees.push(cloneAttendee);
  });
};

const prepareBindData = () => {
  event.value.attendees.forEach((attendee: Attendee) => {
    const result = getTherapyResult(attendee.attendee_id as number);

    attendee.lockDocumentGoals = false;

    attendee.goals = attendee.goals?.filter(
      (goal) => !goal.completed_at || findAttendeeGoal(attendee.attendee_id, goal.id)?.id,
    );

    let openGoals = false;
    result?.goals_measurements.forEach((gm) => {
      if (gm.id !== undefined) {
        openGoals = true;
        gm.show_goal = true;
      }

      const goal = attendee.goals?.find((goal) => goal.id === gm.treatment_goal_id);
      if (goal?.completed_at && openGoals) {
        attendee.lockDocumentGoals = true;
      }
    });

    attendee.documentGoals = openGoals;
    attendee.duration = result?.duration ?? event.value.duration;
    attendee.notes = result?.notes ?? undefined;
    attendee.selectedAttendance = result?.therapy_result_type?.id ?? undefined;
  });
};

const shouldShowDuration = (id: number) =>
  (therapyResultTypes.value as TherapyResultTypeInterface[])?.find(
    (attendance) => attendance.id == id && attendance.is_present == true,
  );

const shouldShowDocumentGoalToggle = (attendance_id: number, goalLength: number) =>
  goalLength && therapyResultTypeIsPresent(attendance_id);

const findAttendeeTherapyResults = (id: number) => {
  return event.value.therapy_results.find((result) => {
    return result.student_id === id;
  });
};

/**
 * find the attendee goal measurements by its parent goal.id (treatment_goal_id)
 * @param attendeeId:number
 * @param id:number
 * @returns GoalMeasurementInterface
 */
function findAttendeeGoal(attendeeId: number, id: number) {
  const attendee = findAttendeeTherapyResults(attendeeId);
  return attendee?.goals_measurements?.find((g: GoalMeasurementsInterface) => g.treatment_goal_id === id);
}

const therapyResultTypeIsPresent = (therapyResultTypeId: number) => {
  return (therapyResultTypes.value as TherapyResultTypeInterface[])
    .filter((e: TherapyResultTypeInterface) => e.is_present)
    .find((s: TherapyResultTypeInterface) => s.id == therapyResultTypeId);
};

const isSingleEvent = (): boolean => {
  if (!event.value.rrule) return true;
  const rruleCheck = RRule.fromString(event.value.rrule as string);
  return rruleCheck.count() > 1 ? false : true;
};

const haveNewAttendees = (): boolean => !!payload.value.find((result) => result.new_attendee === true);

const originalsAttendeesWereRemoved = (): boolean => {
  if (payload.value.length < originalAttendees.value.length) {
    return true;
  }

  originalAttendees.value.forEach((attendee: Attendee) => {
    let myAttendeeWasFound = false;
    myAttendeeWasFound =
      !!payload.value.find((result) => result.therapy_attendee_id === attendee.id) || myAttendeeWasFound;
    if (!myAttendeeWasFound) {
      return true;
    }
  });

  return false;
};

const checkGoalsPayload = (attendee: Attendee) => {
  return therapyResultTypeIsPresent(attendee.selectedAttendance as number) &&
    attendee.documentGoals &&
    (attendee.goals?.length as number) > 0
    ? mountGoalsPayload(attendee.attendee_id)
    : [];
};

const mountGoalsPayload = (attendee_id: number) => {
  const result = event.value.therapy_results.find((result) => result.student_id === attendee_id);

  if (!result) {
    return [];
  }

  let goals_measurements: GoalMeasurementsInterface[] = [];

  result.goals_measurements.forEach((gm) => {
    const localGm: GoalMeasurementsInterface = {
      id: gm.id,
      show_goal: gm.show_goal,
      treatment_goal_id: gm.treatment_goal_id,
      total_trials: gm.total_trials,
      trials: gm.trials,
      percentage: gm.percentage,
      checkbox_order: gm.checkbox_order,
    };

    if (gm.show_goal) goals_measurements.push(localGm);
  });

  return goals_measurements;
};

const isDocumenting = computed(
  () => !!payload.value.find((tr) => (tr && tr.notes !== '') || tr.therapy_result_type_id != undefined),
);

const isCaseloadManagement = computed<boolean>(() =>
  calendarStore.isCaseloadManagement(event.value.therapy_event_type),
);

const isEvaluation = computed<boolean>(() => calendarStore.isEvaluation(event.value.therapy_event_type));

const attendeesNotNew = computed(() => event.value.attendees.filter((attendee) => !attendee.new));

/**
 * if the editing event is before today then all types are allowed, if it's not today then
 *  allow no school, clinician cancelled, customer cancelled. if its TODAY then allow a late cancel
 */
const filterTherapyTypeForFutureEvents = computed(() => {
  if ((clickedEventClickArgs.value?.start as Date) < new Date()) return therapyResultTypes.value;

  const allowed = [
    THERAPY_RESULT_TYPES_NAME.NO_SCHOOL,
    THERAPY_RESULT_TYPES_NAME.CLINICIAN_CANCELLED,
    THERAPY_RESULT_TYPES_NAME.CUSTOMER_CANCELLED,
  ];

  const startDate = new Date(clickedEventClickArgs.value?.start as string);
  const today = new Date();
  if (!dateUtilities.sameDay(startDate, today)) {
    return therapyResultTypes.value?.filter((resultType) => {
      if (resultType.name) {
        return allowed.includes(resultType.name as THERAPY_RESULT_TYPES_NAME);
      }
    });
  } else {
    allowed.push(THERAPY_RESULT_TYPES_NAME.LATE_CANCEL);

    return therapyResultTypes.value?.filter((resultType) => {
      if (resultType.name) {
        return allowed.includes(resultType.name as THERAPY_RESULT_TYPES_NAME);
      }
    });
  }
});

const payload = computed(() =>
  multiAttendee.value.map((attendee) => {
    return {
      new_attendee: attendee.new ?? false,
      attendee_id: attendee.attendee_id,
      notes: attendee.notes,
      therapy_result_type_id: attendee.selectedAttendance,
      duration:
        therapyResultTypeIsPresent(attendee.selectedAttendance as number) && attendee.duration > 0
          ? attendee.duration
          : undefined,
      goals_measurements: checkGoalsPayload(attendee),
    };
  }),
);

const rules = computed(() => {
  return {
    therapy_results: {
      $each: helpers.forEach({
        notes: {
          requiredIfCustom: helpers.withMessage(
            'Please select a note',
            requiredIf((v: string, vm) => {
              return vm.therapy_result_type_id !== undefined;
            }),
          ),
        },
        therapy_result_type_id: {
          requiredIfCustom: helpers.withMessage(
            'Please select a note',
            requiredIf((v: string, vm) => {
              return vm && vm.notes !== '';
            }),
          ),
        },
        duration: {
          requiredIfCustom: helpers.withMessage(
            'Please select a duration',
            requiredIf((v: string, vm) => {
              return therapyResultTypeIsPresent(vm.therapy_result_type_id);
            }),
          ),
        },
      }),
    },
  };
});

const canShowEvaluationAssessmentFiles = computed(() => event.value.therapy_event_type === 'Evaluation');

const onSavedClicked = () => {
  submitted.value = true;
  if (v$.value.$invalid) {
    submitted.value = false;
    return;
  }

  if (!isSingleEvent() && (haveNewAttendees() || originalsAttendeesWereRemoved())) {
    displayDocumentVirtualEventConfirmModal.value = true;
  } else {
    onSave();
  }
};

const openPastDocuments = (attendee: Attendee) => {
  displayPastEventsModal.value = !displayPastEventsModal.value;
  emit('openPastDocuments', attendee);
};

const onSave = async () => {
  let newDate = dateUtilities.formatLocalDateTime(event.value.display_start_at as string, true, true);
  newDate = dateUtilities.formatDateForApi(newDate, true);

  closeDocumentVirtualEventConfirmModal();
  submitted.value = true;
  if (v$.value.$invalid) {
    submitted.value = false;
    return;
  }

  const updated = eventsModalsStore.selectedEventCompletedToEdit ? true : undefined;

  const response = await calendarStore.storeUpdateTherapyResults(
    {
      event_id: event.value.id,
      event_date: newDate,
      start_at: useDateTime().formatDateForApiWithoutConvertTimezone(eventRRule.value.options?.dtstart, true),
      until: useDateTime().formatDateForApiWithoutConvertTimezone(eventRRule.value.options?.until, true),
      therapy_results: payload.value as TherapyResultsInterface[],
      updated,
      duration: event.value.duration,
    },
    originalAttendees.value,
  );

  let messages = '';

  if (response.data.errors !== undefined) {
    let errors = response.data.errors;
    let keys = Object.keys(errors);
    keys.forEach((key) => {
      errors[key].forEach((error: string) => {
        messages += `\n${error}`;
      });
    });
  }

  emit(EMIT.SAVE_DOCUMENT_EVENT, response.status, messages);
};

const v$ = useVuelidate(rules, { therapy_results: payload });

/**
 * update the goal from the TrailGoals->GoalsCheckbox
 * @params {checkboxArray: number[],
 *   max: number,
 *   attendeeId: number,
 *   trialId: number,
 *   trialCount: number,
 *   percentage: number,
 *   type: string}
 */
const updateTrialGoal = (
  value: number[],
  max: number,
  attendeeId: number,
  treatment_goal_id: number,
  trialCount: number,
  percentage: number,
) => {
  const goal: GoalMeasurementsInterface = findAttendeeGoal(attendeeId, treatment_goal_id) as GoalMeasurementsInterface;
  if (goal) {
    goal.checkbox_order = value;
    goal.total_trials = max;
    goal.percentage = percentage;
    goal.trials = trialCount;
  }
};

/**
 * update the slider goal
 * * @params {
 *   attendeeId: number,
 *   goalId: number,
 *   percentage: number,
 *   type: string}
 */
const updatePercentageGoal = (attendeeId: number, treatment_goal_id: number, percentage: number) => {
  const goal: GoalMeasurementsInterface = findAttendeeGoal(attendeeId, treatment_goal_id) as GoalMeasurementsInterface;
  if (goal) goal.percentage = percentage;
};

const updateShouldSaveGoals = (saveGoals: boolean, goalId: number, attendeeId: number) => {
  const goal: GoalMeasurementsInterface = findAttendeeGoal(attendeeId, goalId) as GoalMeasurementsInterface;
  if (goal) goal.show_goal = saveGoals;
};

/**
 * --find the goal measurements for the attendee and attach whether to save/show the goal for the toggle
 * --also declare what component is needed for the goalType (trial or percentage)
 * @param attendee_id {number}
 * @param goals {GoalInterface[]}
 * @return measurements {GoalMeasurementsInterface[]}
 */
const attendeeGoalMeasurements = (attendee_id: number, goals: GoalInterface[]) => {
  const measurements: GoalMeasurementsInterface[] = [];
  const attendeeTherapyResults = event.value.therapy_results.find((result) => result.student_id === attendee_id);

  goals.forEach((goal) => {
    const goalType = attendeeTherapyResults?.goals_measurements?.find((result) => goal.id === result.treatment_goal_id);

    if (goalType) {
      goalType.completed_at = goal.completed_at;
      goalType.show_goal = goalType.show_goal || false;
      goalType.description = goal.description;
      goalType.component =
        goal.treatment_goal_type.title === GOAL_TYPE.TRIALS ? markRaw(TrialsGoals) : markRaw(PercentageGoals);
      measurements.push(goalType);
    }
  });
  return measurements;
};

const emitEditEvent = () => emit(EMIT.EDIT_EVENT);

const rruleWeekdayNumberToString = (weekday: number) => {
  const maps = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  return maps[weekday];
};

const recurrenceToDisplay = () => {
  if (!event.value.rrule) {
    return '';
  }

  if (event.value.rrule.includes('DAILY')) {
    return 'Repeats Daily';
  }

  const rrule = RRule.fromString(event.value.rrule);

  if (event.value.rrule.includes('WEEKLY')) {
    const weekdays = rrule.options.byweekday.map(rruleWeekdayNumberToString);
    const lastElement = weekdays.pop();
    return 'Repeats Weekly on ' + weekdays.join(', ') + (weekdays.length ? ' and ' : '') + lastElement;
  }

  if (event.value.rrule.includes('YEARLY')) {
    return 'Repeats Annually on ' + rrule?.options?.dtstart.toLocaleString('default', { weekday: 'long' });
  }

  if (event.value.rrule.includes('MONTHLY')) {
    const weekNumbers = ['1st', '2nd', '3rd', '4th', '5th'];
    const weekNumber = Math.floor(rrule?.options?.dtstart?.getDate() / 7);
    return `Repeats Monthly on the ${weekNumbers[weekNumber]} ${rrule?.options?.dtstart.toLocaleString('default', {
      weekday: 'long',
    })}`;
  }

  return '';
};

const setTemplateOnNotes = async (index: number) => {
  if (templateType.value[index] === 'Progress Notes') {
    multiAttendee.value[index].notes = templates.progressNotesTemplate;
  } else {
    multiAttendee.value[index].notes = templates.soapTemplate;
  }
  await nextTick();
  let item = document.getElementsByClassName('ql-editor').item(index)?.firstChild as Node;
  document.getSelection()?.setPosition(item, 1);
};

//provide the updateGoals functions for the grand-child
provide('updateTrialGoal', updateTrialGoal);
provide('updatePercentageGoal', updatePercentageGoal);

const evaluteToCanGroup = computed(() => {
  const { attendees } = event.value;
  const is_group = event.value.attendees.find(
    (a) =>
      !a.treatment_services?.find((s) => {
        return s.is_group;
      }),
  );

  if (attendees.length === 1 && !is_group) {
    return true;
  }

  return false;
});

const eventDescription = computed(() => {
  const { event_type_data, therapy_results } = event.value;
  return !isCaseloadManagement.value && event_type_data ? event_type_data.description : therapy_results[0].notes;
});

const filterAttendeesByOrganization = (availableAttendees: Attendee[]) => {
  const allowedOrg = event.value.attendees[0]?.organizations[0].id;
  return availableAttendees.filter((attendee) => {
    if (attendee.organizations.length) return attendee.organizations[0].id === allowedOrg;
  });
};

const onAttendeeChange = () => {
  emit('changeMultiAttendee', multiAttendee.value);
};

const handleOverlappingError = () => {
  if (!usePersonTypes.isSupportAdmin() && !usePersonTypes.isSuperAdmin()) {
    overlappingError.value = true;
  }
};

const { initialRRule } = useGetInitialRRuleObject(event.value as DetailedEventInterface, true);

const eventRRule = ref<Partial<RRule>>(initialRRule.value);

const handleOverlappingOk = () => {
  shouldCheckOverlappingEvents.value = false;
  overlappingError.value = false;
};

const isValidCaseloadManagement = computed(
  () =>
    event.value?.attendees[0]?.organizations.length &&
    event.value.therapy_event_type === EVENT_TYPE.CASELOAD_MANAGEMENT,
);

const checkOverlappingEvents = () => {
  shouldCheckOverlappingEvents.value = true;
};

//This modification to the Editor component is required for compliance with Quill v2
//eslint-disable-next-line
(Editor as any).methods.renderValue = function renderValue(this: { quill?: Quill }, value: string) {
  if (this.quill) {
    if (value) {
      const delta = this.quill.clipboard.convert({ html: value });
      this.quill.setContents(delta, 'silent');
    } else {
      this.quill.setText('');
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (shouldCheckOverlappingEvents.value)
          ? (_openBlock(), _createBlock(_unref(CalendarOverlappingEvents), {
              key: 0,
              duration: event.value.duration,
              "event-id": event.value.id,
              "is-recurring": false,
              rrule: eventRRule.value,
              onError: handleOverlappingError,
              onOk: handleOverlappingOk
            }, null, 8, ["duration", "event-id", "rrule"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Icon, {
            name: "event",
            class: "date-picker-icon mr-3"
          }),
          _createElementVNode("div", null, [
            _createElementVNode("p", null, [
              _createElementVNode("b", _hoisted_4, _toDisplayString(_unref(dateUtilities).formatLongDate(event.value.event_date)), 1),
              _createTextVNode(" " + _toDisplayString(displayStart.value) + "— " + _toDisplayString(displayEnd.value) + " " + _toDisplayString(event.value.host_timezone_abbr), 1)
            ]),
            (_unref(isAdmin) || _unref(isLocked))
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(recurrenceToDisplay()), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (isValidCaseloadManagement.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              _createVNode(_component_Icon, {
                name: "domain",
                class: "material-symbols-outlined mr-3 text-color-blue"
              }),
              _createElementVNode("b", _hoisted_7, _toDisplayString(event.value.attendees[0].organizations[0].name), 1)
            ]))
          : _createCommentVNode("", true),
        (eventDescription.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _createVNode(_component_Icon, {
                name: "notes",
                class: "description-icon material-symbols-outlined mr-3 text-color-orange"
              }),
              _createTextVNode(" " + _toDisplayString(eventDescription.value), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(isClinician) || (isCaseloadManagement.value && !_unref(isLocked)))
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
              (multiAttendee.value.length <= 1)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    name: "person",
                    class: "text-color-blue material-symbols-outlined mr-3"
                  }))
                : (_openBlock(), _createBlock(_component_Icon, {
                    key: 1,
                    name: "group",
                    class: "text-color-blue material-symbols-outlined mr-3"
                  })),
              (!evaluteToCanGroup.value && !isCaseloadManagement.value && !_unref(isLocked))
                ? (_openBlock(), _createBlock(_unref(MultiSelect), {
                    key: 2,
                    id: "attendees",
                    modelValue: multiAttendee.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((multiAttendee).value = $event)),
                    class: "multiselect-custom w-full",
                    "panel-class": "new-event-attendee-select",
                    options: event.value.attendees,
                    "option-label": "attendee.full_name",
                    filter: true,
                    display: "chip",
                    placeholder: "Select Attendees",
                    "show-toggle-all": false,
                    onChange: onAttendeeChange
                  }, null, 8, ["modelValue", "options"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(multiAttendee.value.map((item) => item.attendee?.display_name).join(', ')), 1))
            ]))
          : _createCommentVNode("", true),
        (isCaseloadManagement.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[3] || (_cache[3] = _createElementVNode("label", null, "Caseload Management Type(s)", -1)),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.value.event_type_data.therapy_caseload_management_types, (item) => {
                  return (_openBlock(), _createBlock(_unref(Chip), {
                    key: item.id,
                    label: item.name,
                    class: "px-2 mr-2 border-round-sm bg-gray-200 text-sm font-bold"
                  }, null, 8, ["label"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (canShowEvaluationAssessmentFiles.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_Icon, {
                name: "attachment",
                class: "material-symbols-outlined mr-3 text-color-purple"
              }),
              _createVNode(EventEvaluationAssessmentsFiles, {
                event: event.value,
                "show-assessment-title": ""
              }, null, 8, ["event"])
            ]))
          : _createCommentVNode("", true),
        (isEvaluation.value && event.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "font-bold" }, "Evaluation Type:", -1)),
              _createElementVNode("span", {
                class: "my-2",
                textContent: _toDisplayString(event.value.evaluation?.evaluation_type.title)
              }, null, 8, _hoisted_15)
            ]))
          : _createCommentVNode("", true)
      ]),
      (event.value.attendees && _unref(isClinician) && !isCaseloadManagement.value && !_unref(isLocked))
        ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(multiAttendee.value, (attendee, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: attendee.id,
                class: "mb-3 p-3 bg-white"
              }, [
                (attendee.attendee)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_17, [
                      _createElementVNode("b", null, _toDisplayString(attendee.attendee.full_name), 1),
                      _createVNode(_component_Icon, {
                        name: "history",
                        class: "text-color-gray cursor-pointer p-2",
                        onClick: ($event: any) => (openPastDocuments(attendee.attendee))
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", null, "Attendance", -1)),
                    _createVNode(_unref(Dropdown), {
                      modelValue: attendee.selectedAttendance,
                      "onUpdate:modelValue": ($event: any) => ((attendee.selectedAttendance) = $event),
                      "option-label": "name",
                      "option-value": "id",
                      options: filterTherapyTypeForFutureEvents.value,
                      placeholder: "Select attendance",
                      class: "w-20rem",
                      onChange: checkOverlappingEvents
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]),
                    (submitted.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).therapy_results.$each.$response.$errors[index].therapy_result_type_id, (error) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: error,
                              class: "input-errors"
                            }, [
                              _createElementVNode("div", _hoisted_21, _toDisplayString(error.$message), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      (_openBlock(), _createBlock(_unref(Dropdown), {
                        key: attendee.id,
                        modelValue: templateType.value[index],
                        "onUpdate:modelValue": ($event: any) => ((templateType.value[index]) = $event),
                        options: ['Progress Notes', 'SOAP'],
                        placeholder: "Add a template",
                        class: "flex align-items-center",
                        style: {"background-color":"transparent","border":"none"},
                        onChange: ($event: any) => (setTemplateOnNotes(index))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", null, "Notes", -1)),
                      _createVNode(_unref(Editor), {
                        modelValue: attendee.notes,
                        "onUpdate:modelValue": ($event: any) => ((attendee.notes) = $event),
                        class: "h-8rem"
                      }, {
                        toolbar: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("div", { class: "flex" }, [
                            _createElementVNode("div", { class: "mr-2" }, [
                              _createElementVNode("button", { class: "ql-bold" }),
                              _createElementVNode("button", { class: "ql-italic" }),
                              _createElementVNode("button", { class: "ql-underline" })
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("button", {
                                class: "ql-list",
                                value: "ordered"
                              }),
                              _createElementVNode("button", {
                                class: "ql-list",
                                value: "bullet"
                              }),
                              _createElementVNode("select", { class: "ql-align" })
                            ])
                          ], -1)
                        ]))]),
                        _: 1
                      }, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    (submitted.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).therapy_results.$each.$response.$errors[index].notes, (error) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: error,
                              class: "input-errors"
                            }, [
                              _createElementVNode("div", _hoisted_26, _toDisplayString(error.$message), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (shouldShowDuration(attendee.selectedAttendance))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "required" }, "Duration", -1)),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_InputNumber, {
                              modelValue: attendee.duration,
                              "onUpdate:modelValue": ($event: any) => ((attendee.duration) = $event),
                              step: 15,
                              class: "w-4",
                              "input-class": "w-2",
                              "use-grouping": false,
                              "allow-empty": false
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "document-event-attendees__minutes font-bold ml-2" }, "Minutes", -1))
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).therapy_results.$each.$response.$errors[index].duration, (error) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: error,
                              class: "input-errors"
                            }, [
                              _createElementVNode("div", _hoisted_31, _toDisplayString(error.$message), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_32, [
                  (shouldShowDocumentGoalToggle(attendee.selectedAttendance, attendee.goals.length))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createVNode(_unref(InputSwitch), {
                          modelValue: attendee.documentGoals,
                          "onUpdate:modelValue": ($event: any) => ((attendee.documentGoals) = $event),
                          disabled: attendee.lockDocumentGoals
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "ml-2" }, "Document Goals", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (attendee.documentGoals)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attendeeGoalMeasurements(attendee.attendee_id, attendee.goals), (value) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: value.id
                          }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(value.component), {
                              goal: value,
                              "attendee-id": attendee.attendee_id,
                              "display-past-events-modal": __props.documentModalOpened,
                              onShouldSaveGoals: updateShouldSaveGoals
                            }, null, 40, ["goal", "attendee-id", "display-past-events-modal"]))
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_unref(isAdmin) || (_unref(isLocked) && !isCaseloadManagement.value))
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attendeesNotNew.value, (attendee) => {
              return (_openBlock(), _createBlock(DocumentationItem, {
                key: attendee.id,
                attendee: attendee,
                "therapy-result": getTherapyResult(attendee.attendee_id),
                event: event.value
              }, null, 8, ["attendee", "therapy-result", "event"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(isClinician) && !_unref(isLocked))
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createVNode(_component_AppButton, {
            type: "secondary",
            text: "Edit Event",
            "icon-left": "edit",
            disabled: !_unref(isEditable) && event.value.completed,
            onClick: emitEditEvent
          }, null, 8, ["disabled"]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_AppButton, {
              type: "secondary",
              text: "Cancel",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit(_unref(EMIT).CLOSE_MODAL)))
            }),
            _createVNode(_component_AppButton, {
              type: "primary",
              text: "Save",
              disabled: _unref(v$).$invalid || !isDocumenting.value || overlappingError.value,
              onClick: onSavedClicked
            }, null, 8, ["disabled"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Dialog), {
      visible: displayDocumentVirtualEventConfirmModal.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((displayDocumentVirtualEventConfirmModal).value = $event)),
      modal: true,
      draggable: false,
      class: "document-event-modal"
    }, {
      header: _withCtx(() => [...(_cache[11] || (_cache[11] = [
        _createElementVNode("h2", null, "Edit recurring event", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_unref(EventProcessTypeModal), {
          onCloseConfirmModal: closeDocumentVirtualEventConfirmModal,
          onDocumentEvent: onSave
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})